"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get down () {
        return down;
    },
    get up () {
        return up;
    }
});
const _globals = require("~/utils/globals");
const up = async (knex)=>{
    await knex.schema.alterTable(_globals.MetaTable.USERS, (table)=>{
        table.string('display_name');
        table.string('user_name');
        table.dropColumn('firstname');
        table.dropColumn('lastname');
        table.dropColumn('username');
    });
};
const down = async (knex)=>{
    await knex.schema.alterTable(_globals.MetaTable.USERS, (table)=>{
        table.dropColumn('display_name');
        table.dropColumn('user_name');
        table.string('firstname');
        table.string('lastname');
        table.string('username');
    });
};
